import PropTypes from 'prop-types';

export const propTypes = {
    oncreateNewTemplate: PropTypes.func,
    languageLocale: PropTypes.string,
    defaultTemplatesList: PropTypes.array,
    customTemplatesList: PropTypes.array,
};
